import * as React from "react";

interface Props {
  viewBox?: string;
  color?: string;
  size?: string;
}

export const ProductPredio = (props: Props) => (
  <svg
    width={props.size ?? 20}
    height={props.size ?? 20}
    viewBox={props?.viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 17.167h1.667v1.666H1.333v-1.666H3V3a.833.833 0 0 1 .833-.833h13.334A.833.833 0 0 1 18 3v14.167Zm-1.667 0V3.833H4.667v13.334h11.666Zm-9.166-7.5h2.5v1.666h-2.5V9.667Zm0-3.334h2.5V8h-2.5V6.333Zm0 6.667h2.5v1.667h-2.5V13Zm4.166 0h2.5v1.667h-2.5V13Zm0-3.333h2.5v1.666h-2.5V9.667Zm0-3.334h2.5V8h-2.5V6.333Z"
      fill={props.color ?? "#ffffff"}
    />
  </svg>
);

export const ProductPredio2 = (props: Props) => (
  <svg
    width={props.size ?? 20}
    height={props.size ?? 20}
    viewBox={props?.viewBox ?? "0 0 16 17"}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.00008 13.167V4.30034C2.00004 4.16349 2.04212 4.02994 2.12059 3.91783C2.19907 3.80572 2.31015 3.72047 2.43875 3.67367L8.88608 1.32967C8.93645 1.31134 8.99049 1.30543 9.04362 1.31243C9.09676 1.31943 9.14742 1.33914 9.19132 1.36988C9.23522 1.40063 9.27105 1.44151 9.29579 1.48906C9.32052 1.5366 9.33343 1.58941 9.33342 1.643V4.945L13.5441 6.34834C13.6769 6.39257 13.7924 6.47748 13.8742 6.59104C13.9561 6.70459 14.0001 6.84103 14.0001 6.981V13.167H15.3334V14.5003H0.666748V13.167H2.00008ZM3.33342 13.167H8.00008V3.07034L3.33342 4.76767V13.167ZM12.6667 13.167V7.46167L9.33342 6.35034V13.167H12.6667Z"
      fill={props.color ?? "#666666"}
    />
  </svg>
);
